export default __webpack_public_path__ + "static/media/dashboard_no_projects.12da3d75.svg";